exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/course-sessions.js-WebpackMultiOutput";